import React from 'react';
import './WeddingsPage.scss';

interface WeddingsPageProps {
  menuOpen: boolean;
}

const WeddingsPage: React.FC<WeddingsPageProps> = ({ menuOpen }) => {
  return (
    <div className={`weddings-page ${menuOpen ? 'menu-open' : ''}`}>
      <div className="weddings-page__hero">
        <div className="weddings-page__content">
          <h1 className="weddings-page__title">WEDDING VIDEOGRAPHY</h1>
          
          <div className="weddings-page__intro">
            <p>
              At Stage Door Weddings, we specialize in creating cinematic wedding films that capture 
              the essence of your special day. Our approach combines documentary-style coverage with 
              artistic cinematography to tell your unique love story.
            </p>
          </div>
          
          <div className="weddings-page__services">
            <div className="service-card">
              <h3>Full Day Coverage</h3>
              <p>
                From preparations to the last dance, we'll be there to document every moment of your wedding day.
                Our unobtrusive approach ensures we capture authentic moments without disrupting your celebration.
              </p>
            </div>
            
            <div className="service-card">
              <h3>Highlight Films</h3>
              <p>
                Our highlight films condense the magic of your day into a beautifully crafted short film,
                perfect for sharing with friends and family on social media.
              </p>
            </div>
            
            <div className="service-card">
              <h3>Feature Films</h3>
              <p>
                For couples wanting a more comprehensive film, our feature films include extended coverage
                of your ceremony, speeches, and other key moments from your wedding day.
              </p>
            </div>
          </div>
          
          <div className="weddings-page__approach">
            <h2>Our Approach</h2>
            <div className="approach-cards">
              <div className="approach-card">
                <h3>Before Your Day</h3>
                <p>
                  We believe that your wedding film should be as unique as your relationship. Before your 
                  wedding day, we'll meet with you to understand your vision, preferences, and the special 
                  moments you want us to focus on.
                </p>
              </div>
              
              <div className="approach-card">
                <h3>On Your Day</h3>
                <p>
                  On the day, our experienced team will work discreetly to capture both the planned moments 
                  and the spontaneous ones that make your day special. We use state-of-the-art equipment to 
                  ensure the highest quality footage.
                </p>
              </div>
              
              <div className="approach-card">
                <h3>After Your Day</h3>
                <p>
                  After your wedding, our editors carefully craft your footage into a beautiful film that 
                  tells your story. We pay attention to every detail, from color grading to music selection, 
                  to create a film that you'll treasure for years to come.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeddingsPage;
